import ModalWrapper from '@components/modal/ModalWrapper';
import { Box, TextField, Typography } from '@mui/material';

const RenameTranscriptModal = ({
  open,
  onClose,
  onConfirm,
  isPending,
  transcriptId,
  register,
  errors,
  editTranscriptNameRef,
}) => {
  return (
    <ModalWrapper
      maxWidth="sm"
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      isPending={isPending}
      title={`Rename Transcript`}
      isShowTooltip={false}
    >
      <form>
        <Box py={2}>
          <Typography>ID : {transcriptId}</Typography>
          <TextField
            inputRef={editTranscriptNameRef}
            {...register('name', { required: 'Transcript name is required' })}
            placeholder={'Transcript 1'}
            variant="outlined"
            error={!!errors.name}
            helperText={errors.name?.message}
            sx={{
              mt: 1,
            }}
            fullWidth
          />
        </Box>
      </form>
    </ModalWrapper>
  );
};

export default RenameTranscriptModal;
